import Vue from 'vue/dist/vue.min.js';
import VModal from 'vue-js-modal';
import { quickLinksModal } from "./modals";
import store from "./store";

const quickLinks = () => {

    const links = document.querySelectorAll('.quick-links');

    Vue.use(VModal);

    let quickLinksConstructor = (id) => {
        Vue.component('quick-links', {
            computed: {
                isMobile: function() {
                    return store.state.isMobile;
                }
            },
            watch: {
                isMobile: function() {
                    if (!this.isMobile) {
                        this.$modal.hide('quickLinks');
                    }
                }
            },
            methods: {
                triggerModal() {        
                    let links = this.$refs.links.cloneNode(true);
                    this.$modal.show(
                        quickLinksModal.template,
                        quickLinksModal.name,
                        quickLinksModal.options,
                        quickLinksModal.events(links)
                    )
                }
            },
        });

        new Vue({
            el: `.quick-links-${id}`,
        }).$mount(`.quick-links-${id}`, true);
    }

    if (links.length > 0) {
        links.forEach((item, index) => {
            item.classList.add(`quick-links-${index}`);
            quickLinksConstructor(index);
        })
    }

}

export default quickLinks;